module.exports = __webpack_public_path__ + "img/quizz-step-1-2.118d825a.jpg";